// jQuery Inline Validation plugin
// Author: Kaylee Eluvian 2013
// Requires: jQuery 1.10+, Underscore, Twitter Bootstrap CSS
// -----------------------------------------------------------
// This jQuery plugin allows for neat, client-side validation!
//
// Just set your form out with fields like this:
//
// <div class="control-group">
//     <label for="myControl">label1</label><br>
//     <input type="text"
//         data-valid-msg="this is invalid!"
//         data-valid="^[a-z0-9\s]{0,8}$"
//         required="required"
//         title="What is your info?"
//         maxlength="8"
//         placeholder="info!"
//         id="myControl" />
//     <br>
//     <span class="help-inline">e.g. myinfo</span>
// </div>
//
// Then somewhere in your JavaScript, do: $('#myControl').checkIsValid();
//
// * title is used when the field is not optional to prompt the user.
// * data-valid is used to validate what they type.
// * data-valid-msg is used to tell the user their input is invalid.
// * an input field can be made optional by giving the input the 'optional' CSS class.
// * input fields will have cross-and-tick icons when the user types invalid and valid input.
// * icons can be disabled by giving the input the 'no-icon' CSS class.

define('libs/jquery-Plugins/inlineValidation',['underscore'], function (_) {
    (function () {
        function showInlineValidation(element, message) {
            if (!element.jquery) element = $(element);
            element.attr('aria-invalid', 'true');
            var msg = element.siblings('.errorHolder').children('.help-inline');
            msg.fadeOut(150, function () {
                if (!message) message = element.attr('title');
                msg.text(message).addClass('alert alert-error');
                element.parents('control-group').first().addClass('error');
                msg.slideDown(50, function () {
                    addErrorIcon(element, 'icon-exclamation-sign');
                });
            });
        }

        function addErrorIcon(element, className) {
            if (!element.jquery) element = $(element);
            if (!element.hasClass('no-icon')) {
                element.css("border", "1px solid #CC0000");
                element.next('i').removeClass();
                element.siblings('.errorHolder').children('i').slideUp(50, function () {
                    element.siblings('.errorHolder').children('i').addClass(className);
                    element.siblings('.errorHolder').children('i').slideDown(50);
                });
            }
        }
        function addIcon(element, className) {
            if (!element.jquery) element = $(element);
            if (!element.hasClass('no-icon')) {
                element.css("border", "1px solid #999999");
                element.next('i').removeClass();
                element.siblings('.errorHolder').children('i').removeClass();
                element.siblings('.errorHolder').children('i').hide();
                element.siblings('i').slideUp(50, function () {
                    element.siblings('i').addClass(className);
                    element.siblings('i').slideDown(50);
                });
            }
        }

        function resetInlineMessages(element) {
            if (!element.jquery) element = $(element);
            element.removeAttr('aria-invalid');
            var msg = element.siblings('.errorHolder').children('.help-inline');
            msg.slideUp(150, function () {
                var example = element.attr('placeholder');
                if (example) msg.text('e.g. ' + example)
                msg.removeClass('alert alert-error');
                element.parents('div.control-group').first().removeClass('error');
                element.parents('li.control-group').first().removeClass('error');
                msg.fadeIn(50, function () {
                    addIcon(element, 'icon-ok');
                });
            });
        }

        function isValid(element) {
            if (!element.jquery) element = $(element);
            var pattern = element.attr('data-valid');
            if (!pattern) return true;
            var ve = new RegExp(pattern, 'i');
            if (element.val().search(ve) > -1) return true;
            return false;
        }

        $.fn.resetInlineMessages = function () {
            resetInlineMessages(this);
        }

        $.fn.showInlineValidation = function (message) {
            showInlineValidation(this, message);
        }

        var checkIsValidElement = function (element, message) {
            if (!element.jquery) element = $(element);
            if (element.is(':checkbox')) return;
            if ((element.val() != "" 
                || element.hasClass('optional') 
                || (element.attr('optional') && element.attr('optional').toLowerCase() == "optional")) 
                && isValid(element)) {
                if (element.attr('aria-invalid')) resetInlineMessages(element);
                if (element.next('i').length === 0) addIcon(element, 'icon-ok');
                return;
            }
 
            if (!element.attr('aria-invalid') 
                && !element.val() 
                && !element.hasClass('optional') 
                && (element.attr('optional') && element.attr('optional').toLowerCase() != "optional")) showInlineValidation(element, message);
            if (!element.attr('aria-invalid') 
                && !isValid(element)) showInlineValidation(element, element.attr('data-valid-msg'));
        }

        var checkIsValid_debounced = _.debounce(checkIsValidElement, 150);

        $.fn.checkIsValid = function (message) {
            checkIsValidElement(this, message);
        };

        $.fn.watchIsValid = function (message) {
            $(this).on('keyup', function (e) {
                if (e.which === 9) return; // ignore tab.
                checkIsValid_debounced(this, message);
            });
            $(this).on('blur', function () {
                checkIsValidElement(this, message);
            });
        };
    })(jQuery);
});
